import {Entity} from '../base/entity';
import {SafeUrl} from '@angular/platform-browser';

export class UploadedFileInfo extends Entity {
  fileName: string;
  path: string;
  size: number;
  mimeType: string;

  safeUrl: SafeUrl;
  url: string;
  data: Blob;
}
